<template>
  <div class="nft-summary">
    <div class="nft-summary__image">
      <img ref="target" :src="nftData.image" v-if="shouldShowImage" />
      <video :src="nftData.video" v-if="shouldShowVideo" />
    </div>
    <div class="nft-summary__titles">
      <h3 class="subheadline">Congratulations! You've bought</h3>
      <h1 class="large-headline">{{nftData?.name}}</h1>
    </div>
    <div class="nft-summary__table">
      <h1 class="large-headline">Order #{{orderData?.orderId}}</h1>
      <ul class="subheadline">
        <li>
          <span>NFT name</span>
          <span>{{nftData?.name}}</span>
        </li>
        <li>
          <span>NFT price</span>
          <span>{{toCurrencyFormat(fiatAmount, orderData.fiatType)}} {{orderData.fiatType}}</span>
        </li>
        <li>
          <span>Payment method</span>
          <span>{{orderData.paymentMethod}}</span>
        </li>
        <li>
          <span>Network fee</span>
          <span>{{toCurrencyFormat(feeAmount, orderData.fiatType)}} {{orderData.fiatType}}</span>
        </li>
      </ul>
    </div>
    <ButtonBase @onButtonClick="handleButtonClick" v-if="shouldShowButton">
      {{buttonMessage}}
    </ButtonBase>
  </div>
</template>

<script setup>
import ButtonBase from "@/components/ui/buttons/ButtonBase.vue";

import { computed } from "vue";

import { toCurrencyFormat } from "@/composables/helpers/useStringHelpers";

const props = defineProps({
  orderData: {
    type: Object,
    required: true,
  },
  nftData: {
    type: Object,
    required: true,
  },
  buttonMessage: {
    type: String,
    required: false
  }
});

const emit = defineEmits(["summaryAction"]);
const fiatAmount = computed(() => parseFloat(props.orderData.fiatAmount).toFixed(2));
const feeAmount = computed(() => parseFloat(props.orderData.feeAmount).toFixed(2));
const shouldShowButton = computed(() => props.buttonMessage !== "");
const shouldShowImage = computed(() => props.nftData.image && props.nftData.image !== "")
const shouldShowVideo = computed(() => props.nftData.video && props.nftData.video !== "")

const handleButtonClick = () => {
  emit("summary-action");
}

</script>

<style lang="scss">
.nft-summary {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 4.8rem;

  &__image {
    width: 100%;
    max-width: 30rem;
    display: flex;
    align-items: center;
    margin-bottom: 2rem;

    img {
      width: 100%;
      border-radius: 1rem;
    }

    video {
      width: 100%;
      border-radius: 1rem;
    }
  }

  &__titles {
    text-align: center;
    margin-bottom: 3rem;

    .subheadline {
      color: var(--secondary);
      margin-bottom: 1.2rem;
    }


    @include breakpoint($min-m) {
      .large-headline {
        font-size: 3.2rem;
        margin-bottom: 0.8rem;
      }
    }
  }

  &__table {
    width: 100%;
    background: rgba(255,255,255,0.08);
    border-radius: $border-radius;
    padding: 3rem 2rem;
    margin-bottom: 3rem;

    h1 {
      text-align: center;
      color: var(--secondary);
    }

    ul {
      li {
        display: flex;
        justify-content: space-between;
        padding: 2.4rem 0;
        font-size: $font-subhead;
        @include add-font-weight-settings(500);

        span {
          &:first-child {
            opacity: 0.7;
          }
          
          &:last-child {
            font-weight: 800;
          }
        }

        &:last-of-type {
          padding-bottom: 0;
        }

        &:not(:last-of-type) {
          border-bottom: 1px solid rgba(255,255,255,0.08);
        }
      }
    }
  }

}
</style>
